module.exports = __webpack_public_path__ + "img/UJ-background-profile@2x.41558b3.png";


//////////////////
// WEBPACK FOOTER
// ../website_20/static/img/UJ/UJ-background-profile@2x.png
// module id = iYqH
// module chunks = 0